/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { useContent } from '../../context/ContentContext';
import api from '../../services/api';

const Home = () => {
  const { content,homeImages, aboutImages, services } = useContent();
  const [activeSlide, setActiveSlide] = useState(0);
  const [statsStarted, setStatsStarted] = useState(false);
  const [sponsors, setSponsors] = useState();
  const [loading, setLoading] = useState(true);
  const statsRef = useRef(null);
  const homepageData = content?.homepage || {};
  const homeTitle = homepageData.title || '';
  const homeDescription = homepageData.description;
  const homeInfo = homepageData?.stats;
  const [dynamicAboutImg2, setDynamicAboutImg2] = useState('');
  const [dynamicServices, setDynamicServices] = useState([]);
  const [dynamicHomeImages, setDynamicHomeImages] = useState([]);

   const defaultHomeImages = [
    "/assets/img/DSC09979.jpg",
  ];

  const slides = (dynamicHomeImages && dynamicHomeImages.length > 0) ? dynamicHomeImages : defaultHomeImages;

  const stats = [
    { value: homeInfo?.projects, label: 'States', suffix: '+', description: 'Across South Sudan' },
    { value: 50000, label: 'Lives', suffix: '+', description: 'Transformed' },
    { value: homeInfo?.pharmacists, label: 'Cooperatives', suffix: '+', description: 'Established' },
    { value: 50000, label: 'Trees', suffix: '+', description: 'Planted' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

    useEffect(() => {
    if (services && services.length > 0) {
      setDynamicServices(services);
    } else {
      setDynamicServices([   
      ]);
    }
  }, [services]);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !statsStarted) {
          setStatsStarted(true);
        }
      },
      { threshold: 0.3 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, [statsStarted]);

    useEffect(() => {
    const loadSponsors = async () => {
      setLoading(true);
      try {
        const res = await api.get('/sponsors/home');
        const data = res && res.data ? res.data : (res || []);
        if (Array.isArray(data)) {       
            setSponsors(data);
        }
        
      } catch (err) {
        console.error('Failed to load sponsors:', err);
      } finally {
        setLoading(false);
      }
    };

    loadSponsors();
  }, []);

    useEffect(() => {
    if (homeImages && homeImages.length > 0) {
      setDynamicHomeImages(homeImages);
    } else {
      setDynamicHomeImages(defaultHomeImages);
    }
  }, [homeImages]);


  const AnimatedNumber = ({ target, duration = 2000 }) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
      if (!statsStarted) return;
      let start = 0;
      const increment = target / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) {
          setCount(target);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }, [target, duration, statsStarted]);
    return <>{count.toLocaleString()}</>;
  };

    useEffect(() => {
    if (aboutImages && aboutImages.img2) {
      setDynamicAboutImg2(aboutImages.img2);
    } else {
      setDynamicAboutImg2('/assets/img/havest.png');
    }
  }, [aboutImages]);


  const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }
  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  return imageUrl;
};


  return (
    <>
      <section className="hero">
        <div className="hero__slides">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`hero__slide ${activeSlide === index ? 'active' : ''}`}
              style={{ backgroundImage: `url(${getImageUrl(slide)})` }}
            >
              <div className="hero__overlay"></div>
            </div>
          ))}
        </div>
        
        <div className="hero__content">
          <div className="hero__container">
            <span className="hero__badge">Est. 2022</span>
            <h1 className="hero__title">
              Empowering Communities<br />
              <span>{homeTitle || ''}</span>
            </h1>
            <p className="hero__description">
              {homeDescription || ''}    
            </p>
            <div className="hero__buttons">
              <Link to="/programs" className="btn btn-primary">
                Explore Programs
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link to="/contact" className="btn btn-outline">
                Partner With Us
              </Link>
            </div>
          </div>
        </div>
        
        <div className="hero__indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero__indicator ${activeSlide === index ? 'active' : ''}`}
              onClick={() => setActiveSlide(index)}
            />
          ))}
        </div>
      </section>

      <section className="mission">
        <div className="mission__container">
          <div className="mission__quote">
            <i className="ri-double-quotes-l"></i>
            <p>
              Food security, climate resilience, and environmental stewardship 
              are the foundations of peace, health, and prosperity.
            </p>
            <span>— FARMO Philosophy</span>
          </div>
        </div>
      </section>

      <section className="about-preview">
        <div className="about-preview__container">
          <div className="about-preview__image">
               <img
                src={getImageUrl(dynamicAboutImg2)}
                alt="Farmers in South Sudan"
              
              />
            
            <div className="about-preview__image-caption">
              <i className="ri-group-line"></i>
              <span>Working with {homeInfo?.pharmacists}+ farming cooperatives</span>
            </div>
          </div>
          <div className="about-preview__content">
            <span className="section-tag">Who We Are</span>
            <h2>Growing Hope,<br />{content.about?.title || ''}</h2>
            <p>
              {content.about?.description}
            </p>
            <div className="about-preview__stats">
              <div className="about-preview__stat">
                <span className="stat-number">{homeInfo?.projects}+</span>
                <span className="stat-label">States</span>
              </div>
              <div className="about-preview__stat">
                <span className="stat-number">3+</span>
                <span className="stat-label">Years</span>
              </div>
              <div className="about-preview__stat">
                <span className="stat-number">{homeInfo?.pharmacists}+</span>
                <span className="stat-label">Communities</span>
              </div>
            </div>
            <Link to="/about" className="btn btn-secondary">
              Learn More About Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <section className="programs">
        <div className="programs__container">
          <div className="programs__header">
            <span className="section-tag">Our Programs</span>
            <h2>{content.services?.title}</h2>
            <p>
               {content.services?.description || ''}
            </p>
          </div>
          <div className="programs__grid">
            {dynamicServices.map((program, index) => (
              <div key={index} className="program-card">
                <div className="program-card__icon">
                  <img 
                    className="services__icon2" 
                    src={getImageUrl(program.img || program.image)} 
                    style={{ objectFit: 'cover', width: '100px', height: 'auto', borderRadius: '50%' }} 
                    alt={program.title}
                  />
                </div>
                <h3>{program.title}</h3>
                <p>{program.description}</p>
                <Link to='/programs' className="program-card__link">
                  Learn More <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="impact" ref={statsRef}>
        <div className="impact__container">
          <div className="impact__header">
            <span className="section-tag light">Our Impact</span>
            <h2>Making a Difference</h2>
            <p>Together with our partners and communities, we're creating lasting change</p>
          </div>
          <div className="impact__grid">
            {stats.map((stat, index) => (
              <div key={index} className="impact-card">
                <div className="impact-card__number">
                  {statsStarted ? <AnimatedNumber target={stat.value} /> : '0'}{stat.suffix}
                </div>
                <div className="impact-card__label">{stat.label}</div>
                <div className="impact-card__description">{stat.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="story-highlight">
        <div className="story-highlight__container">
          <div className="story-highlight__content">
            <span className="section-tag">Success Story</span>
            <h2>From Struggle to Strength</h2>
            <p>
              Mary lost her husband during the conflict, leaving her with five children to support. 
              Through FARMO's training program, she learned climate-smart farming techniques and 
              joined a local cooperative. Today, Mary leads a group of 30 women farmers who supply 
              vegetables to the local market.
            </p>
            <div className="story-highlight__stats">
              <div>
                <strong>300%</strong>
                <span>Income Increase</span>
              </div>
              <div>
                <strong>5+</strong>
                <span>Jobs Created</span>
              </div>
              <div>
                <strong>30</strong>
                <span>Women Empowered</span>
              </div>
            </div>
            <Link to="/success-stories" className="btn btn-primary">
              Read More Stories
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="story-highlight__image">
            <img src="/assets/img/farm.png" alt="Mary's farming cooperative" />
          </div>
        </div>
      </section>

      <section className="partners">
        <div className="partners__container">
          <div className="partners__header">
            <span className="section-tag">Our Partners</span>
            <h2>Trusted Collaborations</h2>
            <p>Working together to build a food-secure future</p>
          </div>
          <div className="partners__grid">
            {sponsors?.map(s => (
              <div key={s.id || s._id} className="partner-logo">
                <img src={getImageUrl(s.logo_url || s.logo)} alt={s.name} onError={(e)=>{e.target.onerror=null; e.target.src='/assets/img/placeholder.png'}} />          
              </div>
            )) }
  
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="cta__container">
          <div className="cta__content">
            <h2>Join Us in Building a Food-Secure Future</h2>
            <p>Your support helps us empower communities, protect the environment, and create lasting prosperity.</p>
            <div className="cta__buttons">
              <Link to="/contact" className="btn btn-light">Partner With Us</Link>
              <Link to="/contact" className="btn btn-outline-light">Donate Now</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;